module.exports = __webpack_public_path__ + "static/img/manage-circuit-full.633db807.png";